function injectStyle (ssrContext) {
  require("!!../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3afe3dd7\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./versionDetail.vue")
}
var Component = require("!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./versionDetail.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3afe3dd7\",\"hasScoped\":false}!../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./versionDetail.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/operaPage/versionDetail.vue
// module id = 1692
// module chunks = 107